import { render, staticRenderFns } from "./normal-rate.vue?vue&type=template&id=5d81ec1f&scoped=true&"
import script from "./normal-rate.vue?vue&type=script&lang=js&"
export * from "./normal-rate.vue?vue&type=script&lang=js&"
import style0 from "./normal-rate.vue?vue&type=style&index=0&id=5d81ec1f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81ec1f",
  null
  
)

export default component.exports